export default "<div class=\"page\">\n  <ng-template #pageComponentWrapper></ng-template>\n</div>\n"